/*
==========================================================
FIRESTORE COLLECTIONS
==========================================================
*/

export const FIRESTORE_COLLECTIONS = Object.freeze({

  /*
  ==========================================================
  PLATFORM
  ==========================================================
  */

  ACCESS_REQUESTS: "accessRequests",

  COMPANIES: "companies",

  USERS: "users",

  ADMINS: "admins",

  INTEGRATIONS: "integrations",

  /*
  ==========================================================
  TRANSPORTATION
  ==========================================================
  */

  TRANSPORTATION: "transportation",

  DRIVERS: "drivers",

  VEHICLES: "vehicles",

  CLIENTS: "clients",

  /*
  ==========================================================
  SETTINGS
  ==========================================================
  */

  BOOKING_SOURCES: "bookingSources",

  PAYMENT_TYPES: "paymentTypes",

  SERVICE_TYPES: "serviceTypes",

  ROUTES: "routes",

  LOCATIONS: "locations",

  COMMISSIONS: "commissions",

  TAXES: "taxes",

  CURRENCIES: "currencies",

  SIGN_TEMPLATES: "signTemplates"

});

export default FIRESTORE_COLLECTIONS;